module.exports = __webpack_public_path__ + "img/167.e0eb4937.jpg";